import { render, staticRenderFns } from "./PEditable.vue?vue&type=template&id=fe3fa304&"
import script from "./PEditable.vue?vue&type=script&lang=js&"
export * from "./PEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports